import { ExtendedUser } from './user.dto';
import { Auditable, Dto } from '@damofire/data-commons';
import { DivisionRole, OrganizationLink, User } from '@damofire/data-security';

export interface ExtendedOrganizationLink extends OrganizationLink {
  user?: ExtendedUser;
}

export interface FlatOrganizationLink extends Dto<string>, Auditable {
  name?: string;
  admin?: boolean;
  division?: DivisionRole;
  user?: User;
}
